export default {
  user: JSON.parse(localStorage.getItem("user")) || null,
  accessToken: localStorage.getItem("accessToken") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  drawer: false,
  drawerMini: localStorage.getItem("drawerMini") === "true",
};
